const PageWrap = (props) => {
  return <main class="page-wrap">{props.children}</main>;
};
export default PageWrap;